export default __webpack_public_path__ + "static/media/tl_logo_a_rgb_01_old.23e9024e.png";